import axios from "../axios";

const getConfigures = async function (accessToken) {
    try {
        const response = await axios.get('configure/getConfigures', {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getConfigures;
